export default "__VITE_ASSET__22428cf1__"